// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Sidebar-module-sidebar {
  display: none;
}

@media screen and (min-width: 400px) {

  .sidebar-open #Sidebar-module-sidebar {
    position: relative;
    transform: translateX(0px);
    width: 360px;
  }

  #Sidebar-module-sidebar {
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    height: 100%;
    box-sizing: border-box;
    background-color: var(--body-background);
    flex-shrink: 0;
    overflow-y: auto;
    transition: 0.3s;
    border-right: 1px solid var(--border);
    width: 70px;
  }

}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/Sidebar/Sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;;EAEE;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,YAAY;IACZ,sBAAsB;IACtB,wCAAwC;IACxC,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,qCAAqC;IACrC,WAAW;EACb;;AAEF","sourcesContent":["#sidebar {\r\n  display: none;\r\n}\r\n\r\n@media screen and (min-width: 400px) {\r\n\r\n  :global(.sidebar-open) #sidebar {\r\n    position: relative;\r\n    transform: translateX(0px);\r\n    width: 360px;\r\n  }\r\n\r\n  #sidebar {\r\n    padding: 15px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 15px;\r\n    height: 100%;\r\n    box-sizing: border-box;\r\n    background-color: var(--body-background);\r\n    flex-shrink: 0;\r\n    overflow-y: auto;\r\n    transition: 0.3s;\r\n    border-right: 1px solid var(--border);\r\n    width: 70px;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
export var sidebar = `Sidebar-module-sidebar`;
export default ___CSS_LOADER_EXPORT___;
